import { useQuery} from "@apollo/client"
import {
    GET_CUSTOMER_LOYALTY_QUERY
} from "../components/gql/loyalty"

function useLoyaltyList() {
    const loyaltyResult = useQuery(GET_CUSTOMER_LOYALTY_QUERY, {fetchPolicy: "network-only"})
    let loyalties = []
    if (!loyaltyResult.loading) {
        loyalties = loyaltyResult.data.getCustomerLoyalty.map(loyalty => { return ({ id: loyalty.cardNumber, value: loyalty.cardNumber }) })
    }
    return loyalties
}


export default useLoyaltyList